module.exports = __webpack_public_path__ + "img/bankCheckCash.a4e40413.svg";